import React from "react";
import { Route } from "react-router-dom";
import { StartPage } from "./pages/start-page/start-page";
import { YourNamePage } from "./pages/your-name/your-name";
import { YourBirthdatePage } from "./pages/your-birthdate/your-birthdate";
import { YourBirthPlacePage } from "./pages/your-birthplace/your-birthplace";
import { YourBirthTimePage } from "./pages/your-birthtime/your-birthtime";
import { IntentionsPage } from "./pages/intentions-page/intentions-page";
import { ChooseCardsPage } from "./pages/choose-cards/choose-cards";
import { ResultPage } from "./pages/result/result";

const routes = [
  <Route key={0} index element={<StartPage />} />,
  <Route key={1} path="your-name" element={<YourNamePage />} />,
  <Route key={2} path="your-birthdate" element={<YourBirthdatePage />} />,
  <Route key={3} path="your-birthplace" element={<YourBirthPlacePage />} />,
  <Route key={4} path="your-birthtime" element={<YourBirthTimePage />} />,
  <Route key={5} path="intentions" element={<IntentionsPage />} />,
  <Route key={6} path="choose-cards" element={<ChooseCardsPage />} />,
  <Route key={7} path="result" element={<ResultPage />} />,
];

export { routes };
